const es = {
  locale: 'es',
  Navbar: {
    home: 'Inicio',
    about: 'Sobre mí',
    tech: 'Tecnologías',
    certificates: 'Certificados',
    projects: 'Proyectos',
    contact: 'Conectemos',
  },
  Hero: {
    title: 'Hola, soy Raul',
    greeting:
      'Un desarrollador de software en Deltona, Florida, creando experiencias digitales fluidas. Explora mi trabajo y hablemos de tu proyecto.',
    role: 'Desarrollador de Software',
    button: 'Pr',
    button_two: 'oyec',
    button_three: 'tos',
    stat_years: 'Años Creando',
    stat_stack_title: 'Full Stack',
    stat_stack_copy: 'Web y SaaS',
    stat_ios_copy: 'Apps con SwiftUI',
    location_label: 'Desde Florida',
    profile_copy:
      'Construyendo productos modernos y serenos, con gran UX, arquitectura escalable y atención al detalle lista para producción.',
  },
  AboutMe: {
    title: 'Sobre Mí',
    headline: 'Construyendo productos digitales pensados para web y móvil.',
    experience_label: 'Años de código en producción',
    panel_one_title: 'Frontend y Backend',
    panel_two_title: 'Datos e Integraciones',
    panel_three_title: 'Oficio y Curiosidad',
    one: 'Soy un desarrollador full-stack con más de 5 años de experiencia creando aplicaciones web modernas, escalables y plataformas SaaS. Mi experiencia incluye construir interfaces front-end intuitivas con ',
    front_end: 'React, Next.js, Tailwind CSS y SwiftUI, ',
    one_middle: 'así como desarrollar sistemas back-end robustos con ',
    back_end: 'Spring Boot, Node.js, Express y Supabase',
    two: 'Me especializo en integrar tecnologías potentes como ',
    data_base: 'PostgreSQL, MongoDB, MySQL, OpenAI API y Mapbox API ',
    two_middle:
      'para crear experiencias de usuario fluidas. Con un enfoque sólido en eficiencia y escalabilidad, utilizo herramientas como ',
    version_control: 'Docker, AWS, Git y Stripe ',
    two_final: 'para optimizar flujos de trabajo, despliegues y pagos.',
    three:
      'Impulsado por la curiosidad y el compromiso con la excelencia, me apasiona entregar soluciones digitales de impacto, desarrollar experiencias tanto web como móviles y mejorar continuamente mis habilidades.',
  },
  Technologies: {
    title: 'Tecnologías',
    sub_title: 'Esta es una colección de tecnologías con las que he trabajado.',
    headline:
      'Un stack pensado para lanzar productos completos, no solo maquetas.',
    front_end: 'Front-End',
    languages: 'Lenguajes de Programación',
    languages_sub: 'Lenguajes que domino',
    front_end_sub: 'Tecnologías frontend utilizadas en mis proyectos',
    back_end: 'Back-End',
    back_end_sub: 'Tecnologías backend utilizadas en mis proyectos',
    tools: 'Herramientas y APIs',
    tools_sub: 'Herramientas y APIs usadas en mis proyectos',
  },
  Certificates: {
    title: 'Certificaciones',
    subtitle: 'Estas son algunas de las certificaciones que he obtenido.',
    headline:
      'Crecimiento profesional respaldado por aprendizaje práctico y trabajo real.',
    button: 'Ver Certificación',
  },
  Projects: {
    title: 'Proyectos',
    sub_title: 'Estos son algunos de los proyectos en los que he trabajado.',
    headline:
      'Trabajos seleccionados que combinan visión de producto, buena interfaz e ingeniería limpia.',
    featured: 'Proyecto Destacado',
    infojobs:
      'Landing page de InfoJobs diseñada para mostrar las características y beneficios de la plataforma, facilitando la búsqueda de empleo con una experiencia moderna e intuitiva.',
    nextil:
      'Nextil es una plataforma integral de gestión de citas y negocio diseñada para barberías, salones de belleza y profesionales del sector. Permite administrar citas, clientes, servicios, disponibilidad del personal e ingresos, además de ofrecer reservas en línea, soporte multilingüe y acceso móvil.',
    connectme:
      'ConnectME es una aplicación de redes sociales que permite a los usuarios crear una cuenta, hacer publicaciones e interactuar con otros usuarios. Está construida con el stack MERN.',
    bookme:
      'BookNow es una plataforma que ayuda a propietarios de salones y barberías a hacer crecer su negocio. Ofrece reservas de citas en línea y gestión para los clientes.',
    propet:
      'ProPet es una tienda en línea que permite a los compradores iniciar sesión, explorar múltiples categorías de mascotas, seleccionar productos favoritos, agregarlos al carrito y completar la compra.',
    ims: 'Esta aplicación de gestión de inventario permite a empresas con una gran cantidad de productos administrar y controlar su inventario de manera eficiente.',
    tech: 'Tecnologías',
    live: 'Demo',
    source: 'Código',
  },
  IOS: {
    title: 'Aplicaciones iOS',
    subtitle: 'Estas son algunas de las aplicaciones iOS que he desarrollado.',
    headline:
      'Apps nativas para iPhone diseñadas con la misma atención a la claridad y al detalle.',
    native: 'iOS Nativo',
    store: 'App Store',
    trackmiles_description:
      'Administra tu kilometraje sin esfuerzo con TrackMiles, la aplicación intuitiva diseñada para un seguimiento y organización sencillos. Registra, revisa y obtén información sobre tus viajes con facilidad. Desde estadísticas en tiempo real hasta reportes detallados, TrackMiles ofrece una solución potente y simple para todas tus necesidades de seguimiento.',
    bodytrack_description:
      'BodyTrack es una aplicación de fitness integral que te ayuda a monitorear tu salud al rastrear calorías, pasos, ingesta de agua y entrenamientos. Integrada con HealthKit y MapKit, ofrece metas personalizadas, un panel detallado, recordatorios inteligentes y seguimiento de rutas, todo sin necesidad de dispositivos extra.',
    nextil_ios_description:
      'Nextil es una aplicación iOS nativa desarrollada con SwiftUI que permite a negocios como barberías y salones gestionar citas, clientes, disponibilidad y ganancias desde cualquier lugar. La app se integra con Supabase como backend, Mapbox para mapas y localización, y Stripe para pagos, ofreciendo una experiencia rápida, moderna y enfocada en productividad.',
    tech: 'Tecnologías',
  },
  MacOS: {
    title: 'Aplicaciones macOS',
    subtitle: 'Estas son algunas de las aplicaciones para Mac que he desarrollado.',
    headline:
      'Apps nativas para Mac que hacen el trabajo diario más rápido y sencillo.',
    native: 'macOS Nativo',
    download: 'Descargar',
    imageoptimizer_description:
      'Image Optimizer es una app nativa para Mac que convierte fotos en archivos WebP ligeros y listos para la web, con el tamaño o la calidad exacta que elijas. Incluye recortes predefinidos, versiones para escritorio y móvil y vista previa de antes y después, y nombra cada imagen y escribe su texto alternativo según lo que aparece en ella. La versión 1.3 usa Apple Intelligence, la IA integrada en macOS, así que funciona sin instalar nada y las imágenes nunca salen del Mac, con Apple Vision y modelos locales de Ollama como alternativas.',
  },
  Connect: {
    title: 'Conectemos',
    headline:
      'Abierto a nuevas colaboraciones, trabajo de producto e ideas ambiciosas.',
    subtitle:
      'Siempre estoy abierto a hablar sobre nuevos proyectos, ideas creativas u oportunidades para formar parte de tu visión.',
    cta: 'Ver',
    email: 'Correo',
    linkedin: 'LinkedIn',
    github: 'GitHub',
  },
  Footer: {
    copyright: 'Copyright 2025 - 2026. Todos los derechos reservados.',
  },
};

export default es;
